import { IInterLinkImportDTO } from '@/models/linkingTool.model';
import { TInterLinksImportFormValues } from '../helpers/types';

class InterLinksImportDTO implements IInterLinkImportDTO {
  file: File;

  channelId: number;

  constructor(values: TInterLinksImportFormValues & { channelId: number }) {
    this.file = values.file;
    this.channelId = values.channelId;
  }
}

export default InterLinksImportDTO;
